<template>
    <b-modal id="modal-konfirmasi" title="Konfirmasi Pembayaran" size="lg" 
        no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
        :ok-title="isSubmitting ? 'Membayar...' : 'Bayar'" 
        :ok-disabled="isSubmitting"
        @ok.prevent="doSubmit"
        cancel-title="Tutup" auto-focus-button="ok"
    >
        Konfirmasi untuk melakukan pembayaran 
        <strong v-if="tipePembayaran == 'PP'">
            PERPANJANGAN
            <span v-if="counterPerpanjangan && counterPerpanjangan > 0">(Ke-{{ counterPerpanjangan }} dari {{ maxPerpanjangan }})</span>
        </strong> 
        <strong v-else>PELUNASAN</strong> dengan rincian sebagai berikut:

        <!-- Alert Rollover jika perpanjangan batas maksimal -->
        <b-alert variant="warning" show v-if="isRollover" class="mt-3 mb-3">
            <div class="d-flex align-items-start">
                <i class="fa fa-exclamation-triangle mt-1 mr-2 text-warning" style="font-size: 18px;"></i>
                <div>
                    <strong>Peringatan Rollover Gadai:</strong>
                    <p class="mb-0 small text-dark">
                        {{ rolloverMessage || `Pembayaran ini adalah perpanjangan ke-${maxPerpanjangan} (maksimal). Transaksi ini akan menutup faktur ini dan otomatis menerbitkan Nomor Surat Bukti Gadai (SBG) Baru dengan data barang yang sama.` }}
                    </p>
                </div>
            </div>
        </b-alert>

        <div class="detail-data-wrapper mt-4 mb-4">
            <h6 class="form-title mb-2">DATA PEMBAYARAN</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Total Pembayaran</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(totalPembayaran) }}
                    </strong>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="angsuranPokok > 0 && tipePembayaran == 'PP'">
                <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(angsuranPokok) }}
                    </strong>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-else>
                <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                <b-col>
                    <strong>
                        Rp. 0
                    </strong>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Total Uang yang Harus Diterima</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(angsuranPokok + totalPembayaran) }}
                    </strong>
                </b-col>
            </b-row>
        </div>
        Pastikan anda telah menerima uang sebesar Total Uang Yang Harus Diterima.
    </b-modal>
</template>

<script>
export default {
    name: 'modal-konfirmasi',
    props: {
        isSubmitting: { type: Boolean, required: true },
        tipePembayaran: { type: String, required: true},
        angsuranPokok: { type: Number, required: true },
        totalPembayaran: { type: Number, required: true },
        isRollover: { type: Boolean, default: false },
        counterPerpanjangan: { type: Number, default: 0 },
        maxPerpanjangan: { type: Number, default: 4 },
        rolloverMessage: { type: String, default: '' },
    },
    methods: {
        doSubmit() {
            this.$emit("exec-submit")
        }

    }
}
</script>